import { render, staticRenderFns } from "./ArchiveButton.vue?vue&type=template&id=fb80e67a&"
import script from "./ArchiveButton.vue?vue&type=script&lang=js&"
export * from "./ArchiveButton.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports